import C_FormationType from "../../const/C_FormationType";
import Point3D from "../math/Point3D";


class PatternsData
{
    constructor()
    {

        this.byType =
        {
            // 1 : // METEOR_SHOWER
            // {
            //     1 :
            //     {
            //         spawnDelay: 4,
            //         permanentRotation: true,
            //         fliers:
            //         [
            //             {
            //                 shipId: 5,
            //                 position: new Point3D(-80, -10, 400),
            //                 velocity: new Point3D(2.5, 0, 0),
            //             },
            //             {
            //                 shipId: 5,
            //                 position: new Point3D(-80, 0, 401),
            //                 velocity: new Point3D(2.5, 0, 0),
            //             },
            //             {
            //                 shipId: 5,
            //                 position: new Point3D(-80, 10, 402),
            //                 velocity: new Point3D(2.5, 0, 0),
            //             },
            //
            //             // {
            //             //     shipId: 6,
            //             //     position: new Point3D(-88, -34, 395.1),
            //             //     velocity: new Point3D(2, 1, 0),
            //             // },
            //         ]
            //     },
            //     2 :
            //     {
            //         spawnDelay: 4,
            //         permanentRotation: true,
            //         fliers:
            //         [
            //             {
            //                 shipId: 5,
            //                 position: new Point3D(-80, -5, 399),
            //                 velocity: new Point3D(2.5, 0, 0),
            //             },
            //             {
            //                 shipId: 5,
            //                 position: new Point3D(-80, 5, 404),
            //                 velocity: new Point3D(2.5, 0, 0),
            //             },
            //
            //
            //         ]
            //     },
            //     3 :
            //     {
            //         spawnDelay: 4,
            //         permanentRotation: true,
            //         fliers:
            //             [
            //                 {
            //                     shipId: 5,
            //                     position: new Point3D(-80, 0, 403),
            //                     velocity: new Point3D(2.5, 0, 0),
            //                 },
            //
            //                 {
            //                     shipId: 6,
            //                     position: new Point3D(-80, -40, 395),
            //                     velocity: new Point3D(2, 1.5, 0),
            //                 },
            //             ]
            //     },
            //     4 :
            //     {
            //         spawnDelay: 3,
            //         permanentRotation: true,
            //         fliers:
            //             [
            //                 {
            //                     shipId: 6,
            //                     position: new Point3D(-83, -35.5, 395.11),
            //                     velocity: new Point3D(2, 1.5, 0),
            //                 },
            //                 {
            //                     shipId: 6,
            //                     position: new Point3D(-71, -42.5, 395.10),
            //                     velocity: new Point3D(2, 1.5, 0),
            //                 },
            //                 {
            //                     shipId: 9,
            //                     position: new Point3D(-78.5, -41, 395.15),
            //                     velocity: new Point3D(2, 1.5, 0),
            //                 },
            //             ]
            //     },
            //     5 :
            //     {
            //         spawnDelay: 3,
            //         permanentRotation: true,
            //         fliers:
            //         [
            //             {
            //                 shipId: 6,
            //                 position: new Point3D(-80, -38, 395.13),
            //                 velocity: new Point3D(2, 1.5, 0),
            //             },
            //             {
            //                 shipId: 6,
            //                 position: new Point3D(-72.5, -43, 395.12),
            //                 velocity: new Point3D(2, 1.5, 0),
            //             },
            //         ]
            //     },
            // },


            1 : // METEOR_SHOWER
            {
                waves :
                {
                    1 :
                    {
                        spawnDelay: 4,
                        permanentRotation: true,
                        fliers:
                            [
                                {
                                    shipId: 5,
                                    position: new Point3D(15, -10, 800),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(10, 10, 801),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(-10, -10, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                            ]
                    },
                    2 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                {
                                    shipId: 5,
                                    position: new Point3D(25, -15, 800),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(-20, -10, 801),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(-25, -25, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(40, 25, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 6,
                                    position: new Point3D(-40, -25, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 6,
                                    position: new Point3D(5, 5, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                            ]
                    },
                    3 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                {
                                    shipId: 5,
                                    position: new Point3D(5, -15, 800),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(10, -30, 801),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(-30, 0, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 6,
                                    position: new Point3D(10, 25, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 6,
                                    position: new Point3D(22, -25, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 7,
                                    position: new Point3D(40, 40, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 8,
                                    position: new Point3D(-50, 50, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                            ]
                    },
                    4 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                {
                                    shipId: 5,
                                    position: new Point3D(0, 35, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 7,
                                    position: new Point3D(-20, 40, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 6,
                                    position: new Point3D(0, -20, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 8,
                                    position: new Point3D(32, -15, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 9,
                                    position: new Point3D(35, 15, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                            ]
                    },
                    5 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                {
                                    shipId: 5,
                                    position: new Point3D(-20, 15, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 5,
                                    position: new Point3D(-40, 25, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 6,
                                    position: new Point3D(25, 0, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 7,
                                    position: new Point3D(-15, -20, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 9,
                                    position: new Point3D(35, 0, 800),
                                    velocity: new Point3D(0, 0, 8),
                                },
                            ]
                    },
                    6 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                {
                                    shipId: 8,
                                    position: new Point3D(15, 30, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 8,
                                    position: new Point3D(-17, -25, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 7,
                                    position: new Point3D(35, 5, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                                {
                                    shipId: 7,
                                    position: new Point3D(-30, 40, 802),
                                    velocity: new Point3D(0, 0, 8),
                                },
                            ]
                    },
                }
            },


            2 : // SKIRMISH
            {
                waves :
                {
                    1 :
                    {
                        spawnDelay: 3,
                        rotationSpeed: 0.01,
                        zTriggerRotation: 250,
                        fliers:
                            [
                                {
                                    shipId: 1,
                                    position: new Point3D(0, 20, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(0, -20, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(20, 0, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-20, 0, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(14.14, 14.14, 600),
                                    positionOdd: new Point3D(-14.14, 14.14, 600),
                                    velocity: new Point3D(0, 0, 25),

                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(-14.14, -14.14, 600),
                                    positionOdd: new Point3D(14.14, -14.14, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                            ]
                    },
                    2 :
                    {
                        spawnDelay: 3,
                        rotationSpeed: 0.01,
                        zTriggerRotation: 250,
                        fliers:
                            [
                                {
                                    shipId: 1,
                                    position: new Point3D(5.18, -19.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(19.3, 5.18, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-5.18, 19.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-19.3, -5.18, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(10, 17.3, 600),
                                    positionOdd: new Point3D(-17.3, 10, 600),
                                    velocity: new Point3D(0, 0, 25),

                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(-10, -17.3, 600),
                                    positionOdd: new Point3D(17.3, -10, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                            ]
                    },
                    3 :
                    {
                        spawnDelay: 3,
                        rotationSpeed: 0.01,
                        zTriggerRotation: 250,
                        fliers:
                            [
                                {
                                    shipId: 1,
                                    position: new Point3D(10, -17.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(17.3, 10, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-10, 17.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-17.3, -10, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(5.18, 19.3, 600),
                                    positionOdd: new Point3D(-19.3, 5.18, 600),
                                    velocity: new Point3D(0, 0, 25),

                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(-5.18, -19.3, 600),
                                    positionOdd: new Point3D(19.3, -5.18, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                            ]
                    },
                    4 :
                    {
                        spawnDelay: 0,
                        fliers :
                        [
                            {
                                shipId: 4,
                                positionEven: new Point3D(-25, -25, 601),
                                positionOdd: new Point3D(25, 25, 601),
                                velocity: new Point3D(0, 0, 15),
                            }
                        ]
                    },
                    5 :
                    {
                        spawnDelay: 3,
                        rotationSpeed: 0.01,
                        zTriggerRotation: 250,
                        fliers:
                            [
                                {
                                    shipId: 1,
                                    position: new Point3D(14.14, 14.14, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-14.14, 14.14, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(14.14, -14.14, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-14.14, -14.14, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(0, 20, 600),
                                    positionOdd: new Point3D(-20, 0, 600),
                                    velocity: new Point3D(0, 0, 25),

                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(0, -20, 600),
                                    positionOdd: new Point3D(20, 0, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                            ]
                    },
                    6 :
                    {
                        spawnDelay: 3,
                        rotationSpeed: 0.01,
                        zTriggerRotation: 250,
                        fliers:
                            [
                                {
                                    shipId: 1,
                                    position: new Point3D(10, 17.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(17.3, -10, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-10, -17.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-17.3, 10, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(-5.18, 19.3, 600),
                                    positionOdd: new Point3D(-19.3, -5.18, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(5.18, -19.3, 600),
                                    positionOdd: new Point3D(19.3, 5.18, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                            ]
                    },
                    7 :
                    {
                        spawnDelay: 3,
                        rotationSpeed: 0.01,
                        zTriggerRotation: 250,
                        fliers:
                            [
                                {
                                    shipId: 1,
                                    position: new Point3D(5.18, 19.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(19.3, -5.18, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-5.18, -19.3, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 1,
                                    position: new Point3D(-19.3, 5.18, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(-10, 17.3, 600),
                                    positionOdd: new Point3D(-17.3, -10, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                                {
                                    shipId: 2,
                                    positionEven: new Point3D(10, -17.3, 600),
                                    positionOdd: new Point3D(17.3, 10, 600),
                                    velocity: new Point3D(0, 0, 25),
                                },
                            ]
                    },
                    8:
                    {
                        spawnDelay: 0,
                        waveCircle: true,
                        circleDetails : new Point3D(.3, 3, 3),
                        zTrigger: 250,
                        fliers:
                        [
                            {
                                shipId: 3,
                                position: new Point3D(0, -10, 602),
                                velocity: new Point3D(0, 0, 25),
                            }
                        ]
                    }
                }
            },
            3 : // RESCUE_MISSION
            {
                waves :
                {
                    1:
                    {
                        spawnDelay: 4,
                        fliers:
                        [
                            {
                                shipId: 21,
                                position: new Point3D(0, 20, 600),
                                velocity: new Point3D(0, 0, 10),
                            }
                        ]
                    },
                    2:
                    {
                        spawnDelay: 4,
                        fliers:
                        [
                            {
                                shipId: 21,
                                position: new Point3D(0, -20, 600),
                                velocity: new Point3D(0, 0, 10),
                            }
                        ]
                    },
                    3:
                    {
                        spawnDelay: 4,
                        fliers:
                        [
                            {
                                shipId: 21,
                                position: new Point3D(20, 0, 600),
                                velocity: new Point3D(0, 0, 10),
                            }
                        ]
                    },
                    4:
                    {
                        spawnDelay: 4,
                        fliers:
                        [
                            {
                                shipId: 21,
                                position: new Point3D(-20, 0, 600),
                                velocity: new Point3D(0, 0, 10),
                            }
                        ]
                    },
                }
            },
            4 : // COLLECTION
            {
                waves :
                {
                    1 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                        [
                            // group 1
                            {
                                shipId: 11,
                                position: new Point3D(0, -30, 700),
                                velocity: new Point3D(0.1, 0.1, 10),
                            },
                            {
                                shipId: 12,
                                position: new Point3D(2, -23, 680),
                                velocity: new Point3D(0.1, 0.1, 10),
                            },
                            {
                                shipId: 12,
                                position: new Point3D(-5, -25, 690),
                                velocity: new Point3D(0.1, 0.1, 10),
                            },
                            {
                                shipId: 12,
                                position: new Point3D(-3, -34, 710),
                                velocity: new Point3D(0.1, 0.1, 10),
                            },
                            // group 2
                            {
                                shipId: 17,
                                position: new Point3D(40, 30, 356),
                                velocity: new Point3D(-1.6, -1.3, 0),
                            },
                            {
                                shipId: 17,
                                position: new Point3D(40, 25, 349.5),
                                velocity: new Point3D(-1.6, -1.3, 0),
                            },
                        ]
                    },
                    2 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                        [
                            // group 1
                            {
                                shipId: 10,
                                position: new Point3D(20, 0, 700),
                                velocity: new Point3D(0.1, 0.3, 10),
                            },
                            {
                                shipId: 12,
                                position: new Point3D(20, 8, 680),
                                velocity: new Point3D(0.1, 0.3, 10),
                            },
                            {
                                shipId: 12,
                                position: new Point3D(25, -3, 680),
                                velocity: new Point3D(0.1, 0.3, 10),
                            },
                            {
                                shipId: 11,
                                position: new Point3D(15, 5, 720),
                                velocity: new Point3D(0.1, 0.3, 10),
                            },
                            {
                                shipId: 15,
                                position: new Point3D(20, -5, 710),
                                velocity: new Point3D(0.1, 0.3, 10),
                            },
                            // group 2
                            {
                                shipId: 19,
                                position: new Point3D(0, -8, 700),
                                velocity: new Point3D(0, -0.16, 10),
                            },
                            {
                                shipId: 19,
                                position: new Point3D(-6, 6, 701),
                                velocity: new Point3D(-0.07, 0.07, 10),
                            },
                            {
                                shipId: 19,
                                position: new Point3D(6, 6, 702),
                                velocity: new Point3D(0.07, 0.07, 10),
                            },
                        ]
                    },
                    3 : {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                        [
                            // group 1
                            {
                                shipId: 13,
                                position: new Point3D(35, -10, 700),
                                velocity: new Point3D(-0.15, 0, 10),
                            },
                            {
                                shipId: 13,
                                position: new Point3D(30, -5, 703),
                                velocity: new Point3D(-0.15, 0, 10),
                            },
                            {
                                shipId: 14,
                                position: new Point3D(32, -8, 702),
                                velocity: new Point3D(-0.15, 0, 10),
                            },
                            {
                                shipId: 14,
                                position: new Point3D(34, -14, 690),
                                velocity: new Point3D(-0.15, 0, 10),
                            },
                            // group 2
                            {
                                shipId: 18,
                                position: new Point3D(40, 6, 685),
                                velocity: new Point3D(-0.15, 0, 10),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-34, -6, 684),
                                velocity: new Point3D(0.15, 0, 10),
                            }
                        ]
                    },
                    4 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                // group 1
                                {
                                    shipId: 13,
                                    position: new Point3D(-40, 30, 700),
                                    velocity: new Point3D(0.15, -0.1, 10),
                                },
                                {
                                    shipId: 14,
                                    position: new Point3D(-40, 35, 705),
                                    velocity: new Point3D(0.15, -0.1, 10),
                                },
                                {
                                    shipId: 14,
                                    position: new Point3D(-35, 28, 690),
                                    velocity: new Point3D(0.15, -0.1, 10),
                                },
                                // group 2
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 30, 350.5),
                                    velocity: new Point3D(1.5, -1.5, 0),
                                },
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 25, 348.5),
                                    velocity: new Point3D(1.5, -1.5, 0),
                                },
                            ]
                    },
                    5 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                // group 1
                                {
                                    shipId: 13,
                                    position: new Point3D(-40, -30, 700),
                                    velocity: new Point3D(0.15, 0.1, 10),
                                },
                                {
                                    shipId: 14,
                                    position: new Point3D(-40, -35, 705),
                                    velocity: new Point3D(0.15, 0.1, 10),
                                },
                                {
                                    shipId: 14,
                                    position: new Point3D(-35, -28, 690),
                                    velocity: new Point3D(0.15, 0.1, 10),
                                },
                                // group 2
                                {
                                    shipId: 10,
                                    position: new Point3D(-25, 0, 690),
                                    velocity: new Point3D(0.15, 0.1, 10),
                                },
                                {
                                    shipId: 15,
                                    position: new Point3D(-29, -6, 700),
                                    velocity: new Point3D(0.15, 0.1, 10),
                                },
                                // group 3
                                {
                                    shipId: 17,
                                    position: new Point3D(40, 15, 350),
                                    velocity: new Point3D(-1.6, -1.3, 0),
                                },
                                {
                                    shipId: 17,
                                    position: new Point3D(40, 10, 347),
                                    velocity: new Point3D(-1.6, -1.3, 0),
                                },
                            ]
                    },
                    6 :
                    {
                        spawnDelay: 8,
                        permanentRotation: true,
                        fliers:
                            [
                                // group 1
                                {
                                    shipId: 10,
                                    position: new Point3D(-25, 40, 700),
                                    velocity: new Point3D(0.1, -0.2, 10),
                                },
                                {
                                    shipId: 12,
                                    position: new Point3D(-25, 48, 680),
                                    velocity: new Point3D(0.1, -0.2, 10),
                                },
                                {
                                    shipId: 12,
                                    position: new Point3D(-30, 37, 680),
                                    velocity: new Point3D(0.1, -0.2, 10),
                                },
                                {
                                    shipId: 11,
                                    position: new Point3D(-20, 45, 720),
                                    velocity: new Point3D(0.1, -0.2, 10),
                                },
                                {
                                    shipId: 15,
                                    position: new Point3D(-25, 35, 710),
                                    velocity: new Point3D(0.1, -0.2, 10),
                                },
                                // group 2
                                {
                                    shipId: 20,
                                    position: new Point3D(0, 8, 700),
                                    velocity: new Point3D(0, 0.16, 10),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(-6, -6, 701),
                                    velocity: new Point3D(-0.07, -0.07, 10),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(6, -6, 702),
                                    velocity: new Point3D(0.07, -0.07, 10),
                                },
                                // group 3
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 10, 349),
                                    velocity: new Point3D(1.5, -1.5, 0),
                                },
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 5, 348),
                                    velocity: new Point3D(1.5, -1.5, 0),
                                },
                            ]
                    },
                }
            },
            5 : // SALVAGE_MISSION
            {
                waves :
                {
                    1:
                    {
                        spawnDelay: 5, // 5
                        fliers:
                        [
                            // BOT GROUP - version 1
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 300),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 350),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 400),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 450),
                                velocity: new Point3D(2, 0, 0),
                            },

                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 325),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 375),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 425),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 475),
                                velocity: new Point3D(-2, 0, 0),
                            },
                        ]
                    },
                    2:
                    {
                        spawnDelay: 4, // 9
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400),
                                velocity: new Point3D(2, 0, 0),
                            }
                        ]
                    },
                    3:
                    {
                        spawnDelay: 1, // 10
                        fliers :
                        [
                            // TOP GROUP version 1
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 300),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 350),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 400),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 450),
                                velocity: new Point3D(2, 0, 0),
                            },

                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 325),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 375),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 425),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 475),
                                velocity: new Point3D(-2, 0, 0),
                            },
                        ]
                    },
                    4:
                    {
                        spawnDelay: 2, // 12
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400.1),
                                velocity: new Point3D(2, 0, 0),
                            }
                        ]
                    },
                    5:
                    {
                        spawnDelay: 3, // 15
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400.2),
                                velocity: new Point3D(2, 0, 0),
                            }
                        ]
                    },
                    6:
                    {
                        spawnDelay: 3, // 18
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                    // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400.3),
                                velocity: new Point3D(2, 0, 0),
                            },
                    // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    7:
                    {
                        spawnDelay: 3, // 21
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400.4),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400.1),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    8:
                    {
                        spawnDelay: 3, // 24
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400.5),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400.2),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    9:
                    {
                        spawnDelay: 3, // 27
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400.6),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400.3),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    10:
                    {
                        spawnDelay: 3, // 30
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400.7),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400.4),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    11:
                    {
                        spawnDelay: 0, // 30
                        fliers:
                        [
                        // BOTTOM GROUP version 2
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 300.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-30, 35, 350.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-25, 35, 400.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-30, 35, 450.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 500.1),
                                velocity: new Point3D(2, 0, 0),
                            },

                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 325.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(30, 35, 375.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(25, 35, 425.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(30, 35, 475.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 525.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                        ]
                    },
                    12:
                    {
                        spawnDelay: 3, // 33
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400.5),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    13:
                    {
                        spawnDelay: 3, // 36
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400.6),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    14:
                    {
                        spawnDelay: 3, // 39
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers:
                        [
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400.7),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    15:
                    {
                        spawnDelay: 4, // 43
                        fliers:
                        [
                            // TOP GROUP version 2
                            {
                                shipId: 20,
                                position: new Point3D(-15, -35, 300.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-20, -35, 350.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-25, -35, 400.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-30, -35, 450.1),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 500.1),
                                velocity: new Point3D(2, 0, 0),
                            },

                            {
                                shipId: 20,
                                position: new Point3D(15, -35, 325.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(20, -35, 375.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(25, -35, 425.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(30, -35, 475.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 525.1),
                                velocity: new Point3D(-2, 0, 0),
                            },
                        ]
                    },
                    16:
                    {
                        spawnDelay: 12, // 55
                        fliers:
                        [
                            // BOT GROUP version 3
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 300.2),
                                velocity: new Point3D(2.333, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-30, 35, 350.2),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-25, 35, 400.2),
                                velocity: new Point3D(1.667, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-30, 35, 450.2),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 500.2),
                                velocity: new Point3D(2.333, 0, 0),
                            },

                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 325.2),
                                velocity: new Point3D(-2.333, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(30, 35, 375.2),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(25, 35, 425.2),
                                velocity: new Point3D(-1.667, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(30, 35, 475.2),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 525.2),
                                velocity: new Point3D(-2.333, 0, 0),
                            },
                        ]
                    },
                    17:
                    {
                        spawnDelay: 5, // 60
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400),
                                velocity: new Point3D(2, 0, 0),
                            }
                        ]
                    },
                    18:
                    {
                        spawnDelay: 3, // 63
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400.1),
                                velocity: new Point3D(2, 0, 0),
                            }
                        ]
                    },
                    19:
                    {
                        spawnDelay: 3, // 66
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400.2),
                                velocity: new Point3D(2, 0, 0),
                            }
                        ]
                    },
                    20:
                    {
                        spawnDelay: 3, // 69
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400.3),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    21:
                    {
                        spawnDelay: 3, // 72
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400.4),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400.1),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    22:
                    {
                        spawnDelay: 3, // 75
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400.5),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400.2),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    23:
                    {
                        spawnDelay: 1, // 76
                        fliers:
                        [
                            // TOP GROUP version 3
                            {
                                shipId: 20,
                                position: new Point3D(-15, -35, 300.2),
                                velocity: new Point3D(1.333, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-20, -35, 350.2),
                                velocity: new Point3D(1.667, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-25, -35, 400.2),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-30, -35, 450.2),
                                velocity: new Point3D(2.333, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 500.2),
                                velocity: new Point3D(2.667, 0, 0),
                            },

                            {
                                shipId: 20,
                                position: new Point3D(15, -35, 325.2),
                                velocity: new Point3D(-1.333, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(20, -35, 375.2),
                                velocity: new Point3D(-1.667, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(25, -35, 425.2),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(30, -35, 475.2),
                                velocity: new Point3D(-2.333, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 525.2),
                                velocity: new Point3D(-2.667, 0, 0),
                            },
                        ]
                    },
                    24:
                    {
                        spawnDelay: 2, // 78
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(-40, 10, 400.6),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400.3),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    25:
                    {
                        spawnDelay: 2, // 80
                        fliers:
                        [
                            // BOT GROUP version 4
                            {
                                shipId: 18,
                                position: new Point3D(-35, 35, 300.3),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-30, 35, 350.3),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-25, 35, 400.3),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-20, 35, 450.3),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(-15, 35, 500.3),
                                velocity: new Point3D(2, 0, 0),
                            },

                            {
                                shipId: 18,
                                position: new Point3D(35, 35, 325.3),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(30, 35, 375.3),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(25, 35, 425),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(20, 35, 475.3),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 18,
                                position: new Point3D(15, 35, 525.3),
                                velocity: new Point3D(-2, 0, 0),
                            },
                        ]
                    },
                    26:
                    {
                        spawnDelay: 1, // 81
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // LEFT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(-40, 10, 400.7),
                                velocity: new Point3D(2, 0, 0),
                            },
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400.4),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    27:
                    {
                        spawnDelay: 3, // 84
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400.5),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    28:
                    {
                        spawnDelay: 3, // 87
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // RIGHT GROUP
                            {
                                shipId: 17,
                                position: new Point3D(40, -10, 400.6),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    29:
                    {
                        spawnDelay: 3, // 90
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                            // RIGHT GROUP
                            {
                                shipId: 19,
                                position: new Point3D(40, -10, 400.7),
                                velocity: new Point3D(-2, 0, 0),
                            }
                        ]
                    },
                    30:
                    {
                        spawnDelay: 10, // 100
                        fliers :
                        [
                        ]
                    },
                }
            },
            6 : // GG_MISSION - TESTS
            {
                waves :
                {
                    1 :
                    {
                        spawnDelay: 4,
                        // permanentRotation: true,
                        fliers:
                            [
                        // version 1
                                {
                                    shipId: 18,
                                    position: new Point3D(-35, 35, 300),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(-35, 35, 350),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(-35, 35, 400),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(-35, 35, 450),
                                    velocity: new Point3D(2, 0, 0),
                                },

                                {
                                    shipId: 18,
                                    position: new Point3D(35, 35, 325),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(35, 35, 375),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(35, 35, 425),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(35, 35, 475),
                                    velocity: new Point3D(-2, 0, 0),
                                },


                        // version 2
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-35, 35, 300),
                                //     velocity: new Point3D(2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-30, 35, 350),
                                //     velocity: new Point3D(2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-25, 35, 400),
                                //     velocity: new Point3D(2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-30, 35, 450),
                                //     velocity: new Point3D(2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-35, 35, 500),
                                //     velocity: new Point3D(2, 0, 0),
                                // },
                                //
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(35, 35, 325),
                                //     velocity: new Point3D(-2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(30, 35, 375),
                                //     velocity: new Point3D(-2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(25, 35, 425),
                                //     velocity: new Point3D(-2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(30, 35, 475),
                                //     velocity: new Point3D(-2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(35, 35, 525),
                                //     velocity: new Point3D(-2, 0, 0),
                                // },

                        // version 3
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-35, 35, 300),
                                //     velocity: new Point3D(2.333, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-30, 35, 350),
                                //     velocity: new Point3D(2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-25, 35, 400),
                                //     velocity: new Point3D(1.667, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-30, 35, 450),
                                //     velocity: new Point3D(2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(-35, 35, 500),
                                //     velocity: new Point3D(2.333, 0, 0),
                                // },
                                //
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(35, 35, 325),
                                //     velocity: new Point3D(-2.333, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(30, 35, 375),
                                //     velocity: new Point3D(-2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(25, 35, 425),
                                //     velocity: new Point3D(-1.667, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(30, 35, 475),
                                //     velocity: new Point3D(-2, 0, 0),
                                // },
                                // {
                                //     shipId: 18,
                                //     position: new Point3D(35, 35, 525),
                                //     velocity: new Point3D(-2.333, 0, 0),
                                // },

                        // version 4
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(-35, 35, 300),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(-30, 35, 350),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(-25, 35, 400),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(-20, 35, 450),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(-15, 35, 500),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(35, 35, 325),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(30, 35, 375),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(25, 35, 425),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(20, 35, 475),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 18,
                        //             position: new Point3D(15, 35, 525),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                            ]
                    },
                    2 :
                    {
                        spawnDelay: 4, // 8
                        // permanentRotation: true,
                        fliers:
                            [
                        // version 1
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(-35, -35, 300),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(-35, -35, 350),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(-35, -35, 400),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(-35, -35, 450),
                        //             velocity: new Point3D(2, 0, 0),
                        //         },
                        //
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(35, -35, 325),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(35, -35, 375),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(35, -35, 425),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },
                        //         {
                        //             shipId: 20,
                        //             position: new Point3D(35, -35, 475),
                        //             velocity: new Point3D(-2, 0, 0),
                        //         },

                        // version 2
                                {
                                    shipId: 20,
                                    position: new Point3D(-15, -35, 300),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(-20, -35, 350),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(-25, -35, 400),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(-30, -35, 450),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(-35, -35, 500),
                                    velocity: new Point3D(2, 0, 0),
                                },

                                {
                                    shipId: 20,
                                    position: new Point3D(15, -35, 325),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(20, -35, 375),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(25, -35, 425),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(30, -35, 475),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 20,
                                    position: new Point3D(35, -35, 525),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                            ]
                    },
                    3:
                    {
                        spawnDelay: 4, // 12
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                        [
                    // version 1
                            {
                                shipId: 17,
                                position: new Point3D(-40, 0, 400),
                                velocity: new Point3D(2, 0, 0),
                            }
                        ]
                    },
                    4 :
                    {
                        spawnDelay: 3, // 15
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                            [
                                // version 1
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 0, 400.1),
                                    velocity: new Point3D(2, 0, 0),
                                }
                            ]
                    },
                    5 :
                    {
                        spawnDelay: 3, //18
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                            [
                                // version 1
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 0, 400.2),
                                    velocity: new Point3D(2, 0, 0),
                                }
                            ]
                    },
                    6 :
                    {
                        spawnDelay: 3, // 21
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                            [
                                // version 1 group 1
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 0, 400.3),
                                    velocity: new Point3D(2, 0, 0),
                                },
                            ]
                    },
                    7 :
                    {
                        spawnDelay: 0, // 21
                        fliers :
                            [
                                // version 1 group 1
                                {
                                    shipId: 18,
                                    position: new Point3D(-35, 35, 300),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(-30, 35, 350),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(-25, 35, 400),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(-30, 35, 450),
                                    velocity: new Point3D(2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(-35, 35, 500),
                                    velocity: new Point3D(2, 0, 0),
                                },

                                {
                                    shipId: 18,
                                    position: new Point3D(35, 35, 325),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(30, 35, 375),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(25, 35, 425),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(30, 35, 475),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                                {
                                    shipId: 18,
                                    position: new Point3D(35, 35, 525),
                                    velocity: new Point3D(-2, 0, 0),
                                },
                            ]
                    },
                    8 :
                    {
                        spawnDelay: 3, // 24
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                            [
                                // version 1
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 0, 400.4),
                                    velocity: new Point3D(2, 0, 0),
                                }
                            ]
                    },
                    9 :
                    {
                        spawnDelay: 1, // 25
                        fliers :
                        [
                    // version 1
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 300),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 350),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 400),
                                velocity: new Point3D(2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(-35, -35, 450),
                                velocity: new Point3D(2, 0, 0),
                            },

                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 325),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 375),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 425),
                                velocity: new Point3D(-2, 0, 0),
                            },
                            {
                                shipId: 20,
                                position: new Point3D(35, -35, 475),
                                velocity: new Point3D(-2, 0, 0),
                            },
                        ]
                    },
                    10 :
                    {
                        spawnDelay: 3, // 28
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                            [
                                // version 1
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 0, 400.5),
                                    velocity: new Point3D(2, 0, 0),
                                }
                            ]
                    },
                    11 :
                    {
                        spawnDelay: 3, // 31
                        waveVertical : true,
                        verticalDetails : new Point3D(.6, 0, 1.5),
                        fliers :
                            [
                                // version 1
                                {
                                    shipId: 17,
                                    position: new Point3D(-40, 0, 400.6),
                                    velocity: new Point3D(2, 0, 0),
                                }
                            ]
                    },
                    12 :
                    {
                        spawnDelay: 10,
                        fliers :
                        [

                        ]
                    }
                }
            }
        }
    }
}

export default (new PatternsData);